import { match } from 'ts-pattern'

import { useCartValue } from '../atoms/useCart'

/**
 * Returns the tax price of the cart as a number.
 *
 * Defaults to `0` if the cart is not initialized, empty, or has an error.
 */
export const useCartTaxPrice = () => {
  const cart = useCartValue()

  return match(cart)
    .with({ _tag: 'not_initialized' }, _ => 0)
    .with({ _tag: 'with_items' }, cart => cart.val.taxPrice)
    .with({ _tag: 'updating' }, cart => cart.val.taxPrice)
    .with({ _tag: 'error' }, _ => 0)
    .with({ _tag: 'empty' }, _ => 0)
    .with({ _tag: 'no_cart_id' }, _ => 0)
    .exhaustive()
}
